const fixedDomains = {}

fixedDomains['seguromovil'] = 'seusegurotelemovel',
fixedDomains['seguromultidispositivo'] = 'seuseguromulti-dispositivos',
fixedDomains['seguroportatil'] = 'seusegurolaptop',
fixedDomains['insurama'] = 'insurama'


module.exports = fixedDomains